import type { ConsultantDetail, CreateConsultantInput } from '#shared/types';

/** The consultant being edited, or a blank, active one. */
export function initialConsultantValues(
  record: ConsultantDetail | undefined,
): CreateConsultantInput {
  if (!record) {
    return {
      name: '',
      qualifications: '',
      designation: '',
      registration_no: '',
      signature_data_url: null,
      is_active: true,
    };
  }
  return {
    name: record.name,
    qualifications: record.qualifications,
    designation: record.designation,
    registration_no: record.registration_no ?? '',
    signature_data_url: record.signature_data_url,
    is_active: record.is_active,
  };
}
